import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ProjectService } from '../../../../services/ProjectService';
import { toast } from 'react-toastify';
import { IoIosFolder } from 'react-icons/io';

export default function EmpolyeeFolder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [folders, setFolders] = useState([]);
  const [folderName, setFolderName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      const fetchFolders = async () => {
        try {
          const result = await ProjectService.getProjectFolders(id);
          if (result) {
            setFolders(result);
          }
        } catch (error) {
          toast.error(error?.message);
        }
      };
      fetchFolders();
   }, [id]);

  const createFolder = async () => {
    if (!folderName.trim()) return;

    try {
      setLoading(true);
      const finalData = {
        projectId: id,
        name: folderName,
      };
      const result = await ProjectService.createNewProjectFolder(finalData);
      if (result) {
        toast.success("Folder created");
        setFolders((prev) => [result, ...prev]);
        setFolderName("");
      }else{
        toast.error("Failed to create folder");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to create folder");
    } finally {
      setLoading(false);
    }
  };

  const isDocOrResearch = (name) => {
    const lower = name.toLowerCase();
    return lower.includes("documentation") || lower.includes("research_paper");
  };

  return (
    <div className="p-6">
      {/* Header */}
      {/* <div className="flex justify-end items-center mb-6">

        <div className="flex gap-3">
          <input
            type="text"
            placeholder="Folder name"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            className="border px-3 py-2 rounded"
          />
          <button
            onClick={createFolder}
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            {loading ? "Creating..." : "+ Create Folder"}
          </button>
        </div>
      </div> */}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onClick={() => {
                  if (isDocOrResearch(folder.name)){
                    navigate(`/emp-projects-details/${id}/user-doc-subfolder/${folder.id}`);
                  } else {
                    navigate(`/emp-projects/user-doc/documents/${id}/${folder.id}/0`);
                  }
            }}
            className="border rounded-lg p-3 hover:shadow-md cursor-pointer"
          >
            <div className="flex flex-col items-center gap-3">
              <div className="h-24 w-24">
                <IoIosFolder className="w-full h-full text-[#F4B400]" />
              </div>
              <div className="flex items-center justify-center px-4">
                <h2 className="text-center max-w-full break-all">
                  {folder.name}
                </h2>
              </div>
            </div>
          </div>
          
        ))}

        {folders.length === 0 && (
          <p className="col-span-full text-center text-gray-500">
            No folders found
          </p>
        )}
      </div>
    </div>
  )
}
